import { render, staticRenderFns } from "./ReporteConfronta.vue?vue&type=template&id=e17622aa&scoped=true"
import script from "./ReporteConfronta.vue?vue&type=script&lang=js"
export * from "./ReporteConfronta.vue?vue&type=script&lang=js"
import style0 from "./ReporteConfronta.vue?vue&type=style&index=0&id=e17622aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17622aa",
  null
  
)

export default component.exports